<template>
	<div class="dankal-image-upload">
		<div class="add-box flex flex-c" style="margin: 0;padding: 0;" v-if="list.length < limit && !disabled">
			<el-upload class="upload-demo" drag :limit='1' :file-list='list' accept='.pdf,.ppt'
				:on-success='uploadSuccess' :action='urlDomain+"/v1/common/Upload"'>
				<i class="el-icon-upload" style="font-size: 42px;"></i>
				<div class="el-upload__text">上传文件</div>
			</el-upload>
		</div>
	</div>
</template>

<script>
	import ImageCompressor from 'image-compressor.js';
	import {
		uploadImgFile,
		qiniuInfo
	} from '@/api/common';
	import {
		mapState,
		mapActions
	} from 'vuex';
	import utils from "@/jslibs/utils";
	import {
		imgDomain,
		urlDomain
	} from '@/configs/env';

	export default {
		name: 'DankalImageUpload',
		data() {
			return {
				urlDomain,
				minNum: 0,
				list: [],
				imgDomain,
				toast: '',
				file_type: this.type, //图片还是视频
			}
		},
		created() {},
		props: {
			limit: {
				type: Number,
				default: 5,
			},
			currentIndex: {
				type: Number,
				default: 0,
			},
			quatity: {
				type: Number,
				default: 0.6,
			},
			type: {
				type: String,
				default: 'image',
			},
			disabled: {
				type: Boolean,
				default: false
			},
			onloadImage: {
				type: String,
				default: ""
			},
			isBanner: {
				type: Boolean,
				default: false
			}
		},
		computed: {
			...mapState(['bucket_domain_token'])
		},
		mounted() {
			if (this.onloadImage) {
				this.list.push({
					name: this.onloadImage.split(imgDomain)[1],
					url: this.onloadImage
				})
			}
			console.log(this.list, '文件列表')
		},
		methods: {
			uploadSuccess(res, file) {
				this.$emit('input', imgDomain + res.result, this.currentIndex);
			},
		},
		watch: {
			// onloadImage(val) {
			// 	if (val) {
			// 		this.list = [];
			// 		this.showInput = false;
			// 		this.list.push(val);
			// 		console.log(val, "图片信息")
			// 	}
			// }
		}
	};
</script>

<style lang="less" scoped>
	.dankal-image-upload {
		display: flex;
		flex-wrap: inherit;

		p {
			position: relative;
			min-width: 150px;
			min-height: 150px;
			margin: 20px 10px 20px 30px;
			float: left;

			.upload_img {
				width: 150px;
				height: 150px;
				object-fit: cover;
			}

			.close {
				width: 20px;
				height: 20px;
				position: absolute;
				right: 0;
				cursor: pointer;
			}
		}

		.add-box {
			display: flex;
			flex-direction: column;
			padding-left: 20px;
			margin-top: 20px;

			.add {
				width: 150px;
				height: 150px;
			}

			span {
				color: #CFCFCF;
				font-size: .22rem;
			}
		}
	}
</style>